var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7337 32.0001L52.5337 15.2001C53.6003 14.1334 53.6003 12.5334 52.5337 11.4667C51.467 10.4001 49.867 10.4001 48.8003 11.4667L32.0003 28.2667L15.2003 11.4667C14.1337 10.4001 12.5337 10.4001 11.467 11.4667C10.4003 12.5334 10.4003 14.1334 11.467 15.2001L28.267 32.0001L11.467 48.8001C10.9337 49.3334 10.667 49.8667 10.667 50.6667C10.667 52.2667 11.7337 53.3334 13.3337 53.3334C14.1337 53.3334 14.667 53.0668 15.2003 52.5334L32.0003 35.7334L48.8003 52.5334C49.3337 53.0668 49.867 53.3334 50.667 53.3334C51.467 53.3334 52.0003 53.0668 52.5337 52.5334C53.6003 51.4668 53.6003 49.8667 52.5337 48.8001L35.7337 32.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.dc644d484bbec2117c860b91a83206d5.svg";
export { ForwardRef as ReactComponent };